import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { CustomerSidebar } from '../../components/customer/Sidebar';
import { useAuth } from '../../components/auth/AuthContext';
export function CustomerPortal() {
  const {
    user,
    isAuthenticated,
    isCustomer
  } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Redirect if not authenticated or not a customer
  if (!isAuthenticated || !isCustomer) {
    return <Navigate to="/auth/customer-login" replace data-id="element-751" />;
  }
  return <div className="flex h-screen bg-gray-50" data-id="element-752">
      {/* Desktop sidebar */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-753">
        <CustomerSidebar data-id="element-754" />
      </div>
      {/* Mobile sidebar */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-40 md:hidden" data-id="element-755">
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setIsMobileMenuOpen(false)} data-id="element-756"></div>
          <div className="relative flex flex-col w-full max-w-xs h-full bg-white" data-id="element-757">
            <div className="absolute top-0 right-0 pt-2 pr-2" data-id="element-758">
              <button className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setIsMobileMenuOpen(false)} data-id="element-759">
                <X className="h-6 w-6 text-gray-400" data-id="element-760" />
              </button>
            </div>
            <CustomerSidebar isMobile closeMobileMenu={() => setIsMobileMenuOpen(false)} data-id="element-761" />
          </div>
        </div>}
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-762">
        <header className="bg-white shadow-sm z-10" data-id="element-763">
          <div className="px-4 sm:px-6 lg:px-8" data-id="element-764">
            <div className="flex justify-between h-16" data-id="element-765">
              <div className="flex items-center md:hidden" data-id="element-766">
                <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={() => setIsMobileMenuOpen(true)} data-id="element-767">
                  <Menu className="h-6 w-6" data-id="element-768" />
                </button>
              </div>
              <div className="flex items-center" data-id="element-769">
                <h1 className="text-xl font-semibold text-gray-900" data-id="element-770">
                  Welcome, {user?.name}
                </h1>
              </div>
              <div className="flex items-center" data-id="element-771">
                <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-772">
                  <span className="text-primary font-medium" data-id="element-773">
                    {user?.name.charAt(0).toUpperCase()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8" data-id="element-774">
          <Outlet data-id="element-775" />
        </main>
      </div>
    </div>;
}